<div class="m-2">

    <ng-container *ngFor="let message of order.communications;">

    <!-- message from the customer -->
    <ng-container *ngIf="message.from==order.userId">
        <div fxLayout="column">
            <div fxLayout="row"  fxLayoutAlign="end start">

                <div style="width: 78%; min-height: 55px; text-align: right; margin: 3px;"   class="msg-container">
                    <div *ngIf="message.msg">{{message.msg}}</div>
                    <mat-grid-list *ngIf="message.images" cols="4" rowHeight="43px" gutterSize="3px">
                     <mat-grid-tile
                       *ngFor="let img of message.images let i=index">
                      <img (click)="show(img.url)" class="cursor-pointer"  [src]="img.url" >
                     </mat-grid-tile>
                     </mat-grid-list>

                </div>

                <mat-icon [inline]="true" style="font-size: 46px;">account_circle</mat-icon>
            </div>

            <span fxLayoutAlign="end" class="mt-2 mb-3 mx-12">{{message.timestamp | date : 'short'}}</span>

        </div>
    </ng-container>

    <!-- message from vendor -->
    <ng-container  *ngIf="message.from!=order.userId" >
        <div fxLayout="column">
            <div fxLayout="row"  fxLayoutAlign="start start">

                <mat-icon [inline]="true" style="font-size: 46px;">account_circle</mat-icon>

                <div style="width: 78%; min-height: 55px; margin: 3px;"   class="msg-container from">
                    <div *ngIf="message.msg">{{message.msg}}</div>
                    <mat-grid-list *ngIf="message.images" cols="4" rowHeight="43px" gutterSize="3px">
                     <mat-grid-tile
                       *ngFor="let img of message.images let i=index">
                       <img  (click)="show(img.url)" class="cursor-pointer"  [src]="img.url" >
                     </mat-grid-tile>
                     </mat-grid-list>
                 </div>

            </div>

            <span fxLayoutAlign="start" class="mt-2 mb-3 mx-12">{{message.timestamp | date : 'short'}}</span>

        </div>
    </ng-container>
    </ng-container>
</div>

<div class="m-2" fxLayout="column" style="border: 1px solid rgba(128, 128, 128, 0.452); border-radius: 22px;">
    <div fxLayout="row" fxLayoutAlign="space-between">

            <textarea matAutosizeMinRows="2" matTextareaAutosize class="m-6" style="border: none; min-width: 68%;" [formControl]="form.get('message')"
                [attr.placeholder]="'type_message'|translate" ></textarea>


              <mat-grid-list style="width: 30%;" cols="4" rowHeight="43px" gutterSize="3px">
                <mat-grid-tile
                *ngFor="let item of files let i=index">
                <mat-icon (click)="deleteImageAt(i)">delete</mat-icon>
                <img style="width: 43px;" (click)="show(item.url)" [src]="item.url" >
            </mat-grid-tile>
              </mat-grid-list>


    </div>

    <div fxLayout="row" fxLayoutAlign="space-between start">
        <div fxLayout="row" >
            <button mat-icon-button type="button" (click)="fileInput.click()">
                <mat-icon>photo</mat-icon>
                <input #fileInput type="file" [multiple]="true" (change)="fileBrowseHandler($event.target.files)" style="display:none;" accept="image/x-png,image/gif,image/jpeg"/>
              </button>

            <!-- <button mat-icon-button type="button" (click)="null"><mat-icon>camera_alt</mat-icon></button> -->
        </div>
        <div class="mb-3 mx-3"><button mat-button type="button" (click)="send()" class="chatBtn">{{"send_message"|translate}}</button></div>
    </div>

</div>


